// Max lengths mirrored from the API request models used by the Settings tabs.
// Keep in sync with the backend [MaxLength]/[SwaggerSchemaPattern] attributes.

// General -> PUT /Company/update (Company)
export const GENERAL_LIMITS = {
  organizationName: 500,
  organizationAddress: 500,
  phoneNumber: 500,
  email: 250,
} as const;

// Locations -> /Pharmacies/update-pharmacy-location (UpdatePharmacyLocationRequestModel),
// rooms (PharmacyRoom), /Pharmacies/add-pharmacy-by-activation-code (activationCode)
export const LOCATION_LIMITS = {
  name: 500,
  address: 500,
  email: 500,
  phone: 500,
  roomName: 500,
  titanCode: 10,
} as const;

// Members -> user update (User)
export const MEMBER_LIMITS = {
  forename: 500,
  surname: 500,
  email: 250,
} as const;

// Teams -> /Teams/save-team, /Teams/update-team (Teams)
export const TEAM_LIMITS = {
  teamName: 50,
  teamDescription: 500,
} as const;

// Roles -> /Role/add, /Role/update (Role)
export const ROLE_LIMITS = {
  name: 500,
  description: 500,
} as const;

// Services -> /Service/add-new-service, /Service/update-new-service (NewServiceModel)
export const SERVICE_LIMITS = {
  name: 1000,
} as const;
